
      import DownloadSimple from './download-simple.vue'
      import type { App, Plugin } from 'vue'

      export const DownloadSimplePlugin: Plugin = {
        install(app: App) {
          app.component('DownloadSimple', DownloadSimple)
        },
      }
      export { DownloadSimple }
      